// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Divider,
//   Chip,
//   Grid,
//   Card,
//   CardContent,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Container,
//   Tabs,
//   Tab,
//   Stack,
//   useMediaQuery,
//   useTheme,
//   Avatar,
//   Badge,
//   Paper,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   IconButton,
// } from "@mui/material";
// import { ExpandLess, ExpandMore } from "@mui/icons-material";
// import {
//   ArrowBack,
//   CheckCircle,
//   PlayCircle,
//   LocationOn,
//   CurrencyRupee,
//   Star,
//   StarBorder,
//   AccessTime,
//   LocalShipping,
//   Category,
//   Info,
//   Palette,
//   Description,
// } from "@mui/icons-material";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import { styled } from "@mui/material/styles";
// import { useSelector } from "react-redux";
// import useAxios from "../useAxios";
// import { restoreAuth } from "../redux/slices/authSlice";
// import ModernLoader from "./ModernLoder";
// import PricingDetails from "./PricingDetails";
// import FactCheckIcon from "@mui/icons-material/FactCheck";
// import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
// // User's city (would normally come from user profile/context)
// const userCity = "kolkata"; // Example - replace with dynamic value
// const ProductCard = styled(Card)(({ theme }) => ({
//   top: 100,
//   borderRadius: "12px",
//   width: "auto",
//   boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//   transition: "all 0.3s ease",
//   "&:hover": {
//     transform: "translateY(-2px)",
//     boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
//   },
// }));

// const ProductDetailView = ({ product, onBack }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const loggedInemail = useSelector((state) => state.auth.email);
//   // State management at the top
//   const [userDetails, setUserDetails] = useState();
//   const [activeTab, setActiveTab] = useState("deliverablesdata");
//   const [selectedTime, setSelectedTime] = useState("standard");
//   const [selectedCity, setSelectedCity] = useState("");
//   const [cityStatus, setCityStatus] = useState("on");
//   const [loading, setLoading] = useState(false);
//   const axiosData = useAxios();
//   const [showPricingDropdown, setShowPricingDropdown] = useState(false);
//   const [durationType, setDurationType] = useState("");
//   const [selectedDuration, setSelectedDuration] = useState("");
//   // Callback to handle city selection
//   const handleCityChange = (city) => {
//     setSelectedCity(city);
//     const statusForCity =
//       product?.status?.[city.charAt(0).toUpperCase() + city.slice(1)];
//     const cityStatus = statusForCity?.toLowerCase() === "off" ? "off" : "on";
//     setCityStatus(cityStatus);
//   };
//   const cityPrice = product.price.find(
//     (item) =>
//       item[userDetails?.city != undefined ? userDetails.city : "chennai"]
//   );
//   const hrs3to4Price = product.price.find((item) => item["3-4 Hrs"]);
//   const hrs7to8Price = product.price[product.price.length - 3];
//   const hrs11to12Price = product.price[product.price.length - 2];
//   const days2Price = product.price.find((item) => item["2 Days"]);
//   // Price calculation
//   const basePrice = cityPrice
//     ? cityPrice[userDetails?.city != undefined ? userDetails.city : "chennai"]
//     : product.price.length > 0
//     ? Object.values(product.price[0])[0]
//     : 0;
//   const basePrice3to4hrs = hrs3to4Price
//     ? hrs3to4Price["3-4 Hrs"]
//     : product.price.length > 0
//     ? Object.values(product.price[0])[0]
//     : 0;
//   const basePrice7to8hrs = hrs7to8Price?.["7-8 Hrs"] ?? 0;
//   const basePrice11to12hrs = hrs11to12Price ? hrs11to12Price["11-12 Hrs"] : 0;
//   const basePrice2days = days2Price ? days2Price["2 Days"] : 0;
//   // Calculate prices based on delivery time
//   const standardPrice = basePrice;
//   const expressPrice = Math.round(basePrice * 1.2); // 20% premium for express
//   const displayPrice =
//     selectedTime === "standard" ? standardPrice : expressPrice;
//   const deliveryTime =
//     selectedTime === "standard" ? "3-5 business days" : "24 hours";
//   const calculateCustomPrice = () => {
//     if (!durationType || !selectedDuration) return 0;

//     const city = userDetails?.city?.toLowerCase();
//     const cityData = product.price[city] || product.price.chennai; // Fallback to New York if city not found

//     if (durationType === "hours") {
//       switch (selectedDuration) {
//         case "3-4":
//           return cityData.base + cityData.hourly * 3.5;
//         case "7-8":
//           return cityData.base + cityData.hourly * 7.5;
//         case "11-12":
//           return cityData.base + cityData.hourly * 11.5;
//         default:
//           return 0;
//       }
//     } else {
//       return cityData.base + cityData.daily * parseInt(selectedDuration);
//     }
//   };
//   const fetchUser = async (email) => {
//     try {
//       const response = await axiosData.get(`getUser/${email}`);
//       if (response.data) {
//         const user = response.data.user;
//         setUserDetails(user);
//         setLoading(false);
//       }
//     } catch (err) {
//       console.error("User get error", err);
//       setLoading(false);
//       // showError(err.response?.data || "Getting user deatails failed. Please try again.");
//     }
//   };

//   useEffect(() => {
//     setLoading(true);
//     const storedAuth = localStorage.getItem("auth");
//     const parsed = JSON.parse(storedAuth);
//     fetchUser(parsed?.email);
//   }, [product]);
//   if (!product || !userDetails) return null;
//   if (loading)
//     return (
//       <ModernLoader size={80} primaryColor="#ab0606ff" text="Processing" />
//     );
//   return (
//     <Container maxWidth="xl" sx={{ py: { xs: 2, md: 3 } }}>
//       {/* Header with back button - improved mobile spacing */}
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           mb: { xs: 2, md: 3 },
//         }}
//       >
//         <Button
//           startIcon={<ArrowBack />}
//           onClick={onBack}
//           sx={{
//             color: "text.primary",
//             mb: 2,
//             borderRadius: "12px",
//             backgroundColor: "background.paper",
//             boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//             transition: "all 0.3s ease",
//             border: "1.5px solid", // Thicker border
//             borderColor: "#d32f2f", // Red border color
//             "&:hover": {
//               backgroundColor: "action.hover",
//               transform: "translateX(-4px)",
//               boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//               borderColor: "#d32f2f", // Keep red on hover
//               "& .MuiSvgIcon-root": {
//                 transform: "translateX(-2px)",
//               },
//             },
//             "&:active": {
//               transform: "translateX(-2px) scale(0.98)",
//             },
//           }}
//           variant="outlined"
//           size={isMobile ? "small" : "medium"}
//         >
//           Back to Products
//         </Button>
//       </Box>

//       {/* Mobile-only product header - appears before main content on small screens */}
//       <Box
//         sx={{
//           display: { xs: "block", md: "none" },
//           mb: 2,
//           opacity: cityStatus === "off" ? 0.4 : 1,
//           pointerEvents: cityStatus === "off" ? "none" : "auto",
//         }}
//       >
//         <Paper
//           elevation={0}
//           sx={{
//             borderRadius: 2,
//             p: 2,
//             backgroundColor: "background.paper",
//           }}
//         >
//           <Typography
//             variant="h3"
//             sx={{
//               fontWeight: 800,
//               mb: 2,
//               color: "primary.main",
//               fontSize: "1.5rem",
//             }}
//           >
//             {product.produt_name}
//           </Typography>
//           <Chip
//             label={`${product.productCategory} Category`}
//             size="small"
//             color="primary"
//             sx={{
//               fontWeight: 800,
//               backgroundColor: "primary.main",
//               height: "24px",
//               fontSize: "0.75rem",
//             }}
//           />
//         </Paper>
//       </Box>

//       <Grid container spacing={{ xs: 2, md: 3 }}>
//         {/* Left Column - Product Visuals */}
//         <Grid
//           item
//           size={{ xs: 12, md: 7 }}
//           order={{ xs: 1, md: 1 }}
//           sx={{
//             opacity:
//               product?.status?.[
//                 selectedCity.charAt(0).toUpperCase() + selectedCity.slice(1)
//               ]?.toLowerCase() === "off"
//                 ? 0.4
//                 : 1,
//             pointerEvents:
//               product?.status?.[
//                 selectedCity.charAt(0).toUpperCase() + selectedCity.slice(1)
//               ]?.toLowerCase() === "off"
//                 ? "none"
//                 : "auto",
//           }}
//         >
//           {/* Desktop-only product header - appears in right column on larger screens */}
//           <Box sx={{ display: { xs: "none", md: "block" } }}>
//             <Paper
//               elevation={0}
//               sx={{
//                 borderRadius: 2,
//                 p: 3,
//                 mb: 3,
//                 backgroundColor: "background.paper",
//               }}
//             >
//               <Typography
//                 variant="h3"
//                 sx={{
//                   fontWeight: 800,
//                   mb: 2,
//                   //fontSize: '2.125rem',
//                   color: "primary.main",
//                 }}
//               >
//                 {product.produt_name}
//               </Typography>
//               <Chip
//                 label={`${product.productCategory} Category`}
//                 size="medium"
//                 color="primary"
//                 sx={{
//                   fontWeight: 600,
//                   backgroundColor: "primary.main",
//                   height: "28px",
//                   fontSize: "0.875rem",
//                 }}
//               />
//             </Paper>
//           </Box>
//           <Paper
//             elevation={0}
//             sx={{
//               borderRadius: 2,
//               //overflow: "hidden",
//               mb: { xs: 2, md: 3 },
//               backgroundColor: "background.paper",
//               position: "relative",
//             }}
//           >
//             <Box
//               sx={{
//                 height: { xs: 250, sm: 300, md: 350 },
//                 //position: "relative",
//                 backgroundColor: "grey.100",
//               }}
//             >
//               <img
//                 src={
//                   product.image_local_url
//                     ? `https://api-productcatelog.bilimbe.in/assets/${encodeURIComponent(
//                         product.image_local_url
//                       )}`
//                     : require("../assets/default-no-image.jpg")
//                 }
//                 alt={product.produt_name}
//                 style={{
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                   filter:
//                     product?.status?.[
//                       selectedCity.charAt(0).toUpperCase() +
//                         selectedCity.slice(1)
//                     ]?.toLowerCase() === "off"
//                       ? "grayscale(1) brightness(0.6)"
//                       : "none",
//                   pointerEvents:
//                     product?.status?.[
//                       selectedCity.charAt(0).toUpperCase() +
//                         selectedCity.slice(1)
//                     ]?.toLowerCase() === "off"
//                       ? "none"
//                       : "auto",
//                 }}
//               />

//               {/* Overlay if product is OFF in selected city */}
//               {product?.status?.[
//                 selectedCity.charAt(0).toUpperCase() + selectedCity.slice(1)
//               ]?.toLowerCase() === "off" && (
//                 <Box
//                   sx={{
//                     position: "absolute",
//                     inset: 0,
//                     //backgroundColor: "rgba(0, 0, 0, 0.45)",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     zIndex: 999,
//                     boxShadow: 24,
//                   }}
//                 >
//                   <Typography
//                     sx={{
//                       backgroundColor: "#fff",
//                       color: "#d32f2f",
//                       px: 4,
//                       py: 1.5,
//                       borderRadius: "32px",
//                       fontWeight: 700,
//                       fontSize: { xs: "1rem", sm: "1rem" },
//                       boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
//                       //textTransform: "uppercase",
//                     }}
//                   >
//                     ?? Product Currently Unavailable in{" "}
//                     {selectedCity.charAt(0).toUpperCase() +
//                       selectedCity.slice(1)}
//                     <Typography
//                       variant="body1"
//                       sx={{
//                         textAlign: "center",
//                         fontWeight: 100,
//                         fontSize: { xs: "0.6rem", sm: "0.6rem" },
//                         //textTransform: "uppercase",
//                       }}
//                     >
//                       Please check other cities or contact support for more
//                       information
//                     </Typography>
//                   </Typography>
//                 </Box>
//               )}
//             </Box>
//           </Paper>
//           {/* Product Info Tabs - improved mobile handling */}
//           <Paper
//             elevation={0}
//             sx={{
//               borderRadius: 2,
//               p: { xs: 2, md: 3 },
//               mb: { xs: 2, md: 3 },
//               backgroundColor: "background.paper",
//             }}
//           >
//             <Tabs
//               value={activeTab}
//               onChange={(e, newValue) => setActiveTab(newValue)}
//               variant={isMobile ? "scrollable" : "standard"}
//               scrollButtons="auto"
//               sx={{
//                 mb: 2,
//                 "& .MuiTabs-indicator": {
//                   height: 3,
//                   borderRadius: "3px 3px 0 0",
//                 },
//               }}
//             >
//               <Tab
//                 label={
//                   <Box display="flex" alignItems="center">
//                     Deliverables from Bilimbe
//                     <IconButton
//                       size="small"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         const textToCopy = product.deliverables.join("\n");
//                         navigator.clipboard.writeText(textToCopy);
//                         // You might want to add a toast/snackbar notification here
//                       }}
//                       sx={{ ml: 1 }}
//                     >
//                       <ContentCopyIcon fontSize="small" />
//                     </IconButton>
//                   </Box>
//                 }
//                 value="deliverablesdata"
//                 icon={isMobile ? null : <VolunteerActivismIcon />}
//                 iconPosition="start"
//                 sx={{
//                   minHeight: 48,
//                   px: { xs: 1, md: 2 },
//                   fontSize: { xs: "0.75rem", sm: "0.875rem" },
//                 }}
//               />
//               <Tab
//                 label={
//                   <Box display="flex" alignItems="center">
//                     To be needed from client side
//                     <IconButton
//                       size="small"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         const textToCopy = product.reqFromClient.join("\n");
//                         navigator.clipboard.writeText(textToCopy);
//                         // You might want to add a toast/snackbar notification here
//                       }}
//                       sx={{ ml: 1 }}
//                     >
//                       <ContentCopyIcon fontSize="small" />
//                     </IconButton>
//                   </Box>
//                 }
//                 value="requirementsdata"
//                 icon={isMobile ? null : <FactCheckIcon />}
//                 iconPosition="start"
//                 sx={{
//                   minHeight: 48,
//                   px: { xs: 1, md: 2 },
//                   fontSize: { xs: "0.75rem", sm: "0.875rem" },
//                 }}
//               />
//               {/* <Tab
//             label="Materials"
//             value="materials"
//             icon={isMobile ? null : <Palette />}
//             iconPosition="start"
//             sx={{
//               minHeight: 48,
//               px: { xs: 1, md: 2 },
//               fontSize: { xs: '0.75rem', sm: '0.875rem' }
//             }}
//           /> */}
//             </Tabs>

//             {/* Tab content remains the same */}
//             {activeTab === "requirementsdata" && (
//               <Box>
//                 <List dense>
//                   {product.reqFromClient?.map((item, index) => (
//                     <ListItem key={index} sx={{ px: 0 }}>
//                       <ListItemIcon sx={{ minWidth: "36px" }}>
//                         <CheckCircle
//                           color="primary"
//                           fontSize={isMobile ? "small" : "small"}
//                         />
//                       </ListItemIcon>
//                       <ListItemText
//                         primary={item}
//                         primaryTypographyProps={{
//                           fontSize: { xs: "0.875rem", md: "1rem" },
//                         }}
//                       />
//                     </ListItem>
//                   ))}
//                 </List>
//               </Box>
//             )}

//             {activeTab === "deliverablesdata" && (
//               <List dense>
//                 {product.deliverables?.map((spec, index) => (
//                   <ListItem key={index} sx={{ px: 0 }}>
//                     <ListItemIcon sx={{ minWidth: "36px" }}>
//                       <CheckCircle
//                         color="primary"
//                         fontSize={isMobile ? "small" : "small"}
//                       />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary={spec}
//                       primaryTypographyProps={{
//                         fontSize: { xs: "0.875rem", md: "1rem" },
//                       }}
//                     />
//                   </ListItem>
//                 ))}
//               </List>
//             )}

//             {/* {activeTab === 'materials' && (
//           <Box sx={{
//             display: 'flex',
//             flexDirection: 'column',
//             flexWrap: 'wrap',
//             minWidth:20,
//             gap: 1,
//             '& .MuiChip-root': {
//               fontSize: { xs: '0.75rem', md: '0.875rem' }
//             }
//           }}>
//             {product.materials_list?.map((material, index) => (
//               <Chip
//                 key={index}
//                 label={material}
//                 variant="outlined"
//                 sx={{
//                   borderColor: 'primary.light',
//                   backgroundColor: 'primary.light'
//                 }}
//                 size={isMobile ? 'small' : 'medium'}
//               />
//             ))}
//           </Box>
//         )} */}
//           </Paper>
//         </Grid>
//         {/* Right Column - Product Actions - sticky on desktop only */}
//         <Grid item size={{ xs: 12, md: 5 }} order={{ xs: 2, md: 2 }}>
//           {" "}
//           <Box
//             sx={{
//               position: { md: "sticky" },
//               top: { md: 20 },
//               marginLeft: { md: "auto" }, // Align to right on desktop
//               paddingLeft: { md: 2 }, // Add some spacing from left column
//             }}
//           >
//             {/* Desktop-only product header is already shown above */}
//             {/* Pricing Card */}
//             {/* <ProductCard sx={{ mb: { xs: 2, md: 3 } }}>
//           <Paper elevation={0} sx={{
//             borderRadius: 2,
//             p: { xs: 2, md: 3 },
//             mb: { xs: 2, md: 3 },
//             backgroundColor: 'background.paper'
//           }}>
//             <Stack spacing={1}>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 0.5 }}>
//                   Pricing for
//                 </Typography>
//                 <Typography variant="h5" sx={{
//                   fontWeight: 700,
//                   fontSize: { xs: '1.25rem', md: '1.5rem' }
//                 }}>
//                   {userDetails?.city?.charAt(0).toUpperCase() + userDetails.city.slice(1)}
//                 </Typography>
//               </Box>

//               <Divider sx={{ my: 1 }} />
//               <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
//                 <Typography variant="body1" sx={{ fontWeight: 600 }}>Total Price:</Typography>
//                 <Box sx={{ textAlign: 'right' }}>
//                   <Typography variant="h4" sx={{
//                     fontWeight: 800,
//                     color: 'primary.main',
//                     fontSize: { xs: '1.5rem', md: '2.125rem' }
//                   }}>
//                     <CurrencyRupee sx={{
//                       fontSize: '0.9em',
//                       mr: 0.2,
//                       verticalAlign: 'middle'
//                     }} />
//                     {displayPrice.toLocaleString('en-IN')}
//                   </Typography>
//                 </Box>
//               </Stack>

//               <Divider />
//               <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
//                 <Typography variant="body1" sx={{ fontWeight: 600 }}>3-4 Hrs Price:</Typography>
//                 <Box sx={{ textAlign: 'right' }}>
//                   <Typography sx={{
//                     fontWeight: 800,
//                     color: 'primary.main',
//                     fontSize: { xs: '1.1rem', md: '1.25rem' }
//                   }}>
//                     <CurrencyRupee sx={{
//                       fontSize: '0.9em',
//                       mr: 0.2,
//                       verticalAlign: 'middle'
//                     }} />
//                     {basePrice3to4hrs.toLocaleString('en-IN')}
//                   </Typography>
//                 </Box>
//               </Stack>

//               <Divider sx={{ my: 1 }} />
//               <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
//                 <Typography variant="body1" sx={{ fontWeight: 600 }}>7-8 Hrs Price:</Typography>
//                 <Box sx={{ textAlign: 'right' }}>
//                   <Typography sx={{
//                     fontWeight: 800,
//                     color: 'primary.main',
//                     fontSize: { xs: '1.1rem', md: '1.25rem' }
//                   }}>
//                     <CurrencyRupee sx={{
//                       fontSize: '0.9em',
//                       mr: 0.2,
//                       verticalAlign: 'middle'
//                     }} />
//                     {basePrice7to8hrs.toLocaleString('en-IN')}
//                   </Typography>
//                 </Box>
//               </Stack>

//               <Divider sx={{ my: 1 }} />

//               <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
//                 <Typography variant="body1" sx={{ fontWeight: 600 }}>11-12 Hrs Price:</Typography>
//                 <Box sx={{ textAlign: 'right' }}>
//                   <Typography sx={{
//                     fontWeight: 800,
//                     color: 'primary.main',
//                     fontSize: { xs: '1.1rem', md: '1.25rem' }
//                   }}>
//                     <CurrencyRupee sx={{
//                       fontSize: '0.9em',
//                       mr: 0.2,
//                       verticalAlign: 'middle'
//                     }} />
//                     {basePrice11to12hrs.toLocaleString('en-IN')}
//                   </Typography>
//                 </Box>
//               </Stack>

//               <Divider sx={{ my: 1 }} />

//               <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
//                 <Typography variant="body1" sx={{ fontWeight: 600 }}>2 Days Price:</Typography>
//                 <Box sx={{ textAlign: 'right' }}>
//                   <Typography sx={{
//                     fontWeight: 800,
//                     color: 'primary.main',
//                     fontSize: { xs: '1.1rem', md: '1.25rem' }
//                   }}>
//                     <CurrencyRupee sx={{
//                       fontSize: '0.9em',
//                       mr: 0.2,
//                       verticalAlign: 'middle'
//                     }} />
//                     {basePrice2days.toLocaleString('en-IN')}
//                   </Typography>
//                 </Box>
//               </Stack>
//             </Stack>
//           </Paper>
//         </ProductCard> */}
//             {/* Pricing Card with select option*/}
//             <ProductCard sx={{ mb: { xs: 2, md: 3 } }}>
//               <Paper
//                 elevation={0}
//                 sx={{
//                   borderRadius: 2,
//                   p: { xs: 2, md: 3 },
//                   backgroundColor: "background.paper",
//                 }}
//               >
//                 <PricingDetails
//                   products={product}
//                   selectCity={selectedCity}
//                   onCityChange={handleCityChange}
//                 />
//               </Paper>
//             </ProductCard>
//             {/* Video Demo - improved mobile layout */}
//             {product.videoLink && product.videoLink !== "no video" && (
//               <Box
//                 sx={{
//                   opacity: cityStatus === "off" ? 0.4 : 1,
//                   pointerEvents: cityStatus === "off" ? "none" : "auto",
//                 }}
//               >
//                 <ProductCard>
//                   <Paper
//                     elevation={0}
//                     sx={{
//                       borderRadius: 2,
//                       p: { xs: 2, md: 3 },
//                       backgroundColor: "background.paper",
//                       width: "100%",
//                     }}
//                   >
//                     <CardContent sx={{ p: { xs: 2, md: 3 }, width: "100%" }}>
//                       <Stack spacing={2} alignItems="center">
//                         <Avatar
//                           sx={{
//                             backgroundColor: "#D32F2F",
//                             //color:"#D32F2F",
//                             width: { xs: 48, md: 56 },
//                             height: { xs: 48, md: 56 },
//                             mb: 1,
//                           }}
//                         >
//                           <PlayCircle
//                             color="white"
//                             sx={{ fontSize: { xs: "24px", md: "28px" } }}
//                           />
//                         </Avatar>
//                         <Typography
//                           variant="h6"
//                           fontWeight={700}
//                           textAlign="center"
//                           sx={{
//                             fontSize: { xs: "1.1rem", md: "1.25rem" },
//                           }}
//                         >
//                           Product Demonstration
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           color="text.secondary"
//                           textAlign="center"
//                           sx={{
//                             mb: 1,
//                             fontSize: { xs: "0.75rem", md: "0.875rem" },
//                           }}
//                         >
//                           See this product in action
//                         </Typography>
//                         <Button
//                           fullWidth
//                           variant="outlined"
//                           size={isMobile ? "small" : "medium"}
//                           startIcon={
//                             <PlayCircle
//                               fontSize={isMobile ? "small" : "medium"}
//                             />
//                           }
//                           href={product.videoLink}
//                           target="_blank"
//                           rel="noopener"
//                           sx={{
//                             py: 1,
//                             borderRadius: "8px",
//                             fontWeight: 600,
//                           }}
//                         >
//                           Watch Video/Output
//                         </Button>
//                       </Stack>
//                     </CardContent>
//                   </Paper>
//                 </ProductCard>
//               </Box>
//             )}
//           </Box>
//         </Grid>
//       </Grid>
//       {/* Overlay Message (when unavailable) */}
//       {/* {cityStatus === "off" && (
//     <Box
//       sx={{
//         position: "fixed",
//         top: "50%",
//         left: "50%",
//         transform: "translate(-50%, -50%)",
//         zIndex: 9999,
//         textAlign: "center",
//         p: 3,
//         backgroundColor: "background.paper",
//         borderRadius: 2,
//         boxShadow: 24
//       }}
//     >
//       <Typography variant="h6" color="error" sx={{ fontWeight: 700, mb: 1 }}>
//         Product Currently Unavailable in {selectedCity.charAt(0).toUpperCase() + selectedCity.slice(1)}
//       </Typography>
//       <Typography variant="body1">
//         Please check other cities or contact support for more information
//       </Typography>
//     </Box>
//   )} */}
//     </Container>
//   );
// };

// export default ProductDetailView;

// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Chip,
//   Paper,
//   Container,
//   Avatar,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Tabs,
//   Tab,
//   Stack,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import { ArrowBack, CheckCircle, PlayCircle } from "@mui/icons-material";
// import useAxios from "../useAxios";
// import ModernLoader from "./ModernLoder";
// import PricingDetails from "./PricingDetails";
// import FactCheckIcon from "@mui/icons-material/FactCheck";
// import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";

// const ProductDetailView = ({ product, onBack }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const [userDetails, setUserDetails] = useState();
//   const [activeTab, setActiveTab] = useState("deliverablesdata");
//   const [selectedCity, setSelectedCity] = useState("");
//   const [loading, setLoading] = useState(false);
//   const axiosData = useAxios();

//   const handleCityChange = (city) => {
//     setSelectedCity(city);
//   };

//   const fetchUser = async (email) => {
//     try {
//       const response = await axiosData.get(`getUser/${email}`);
//       if (response.data) {
//         setUserDetails(response.data.user);
//         setSelectedCity(response.data.user?.city || "chennai");
//         setLoading(false);
//       }
//     } catch (err) {
//       console.error("User get error", err);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     setLoading(true);
//     const storedAuth = localStorage.getItem("auth");
//     const parsed = JSON.parse(storedAuth);
//     fetchUser(parsed?.email);
//   }, [product]);

//   if (!product || !userDetails) return null;
//   if (loading) return <ModernLoader size={80} primaryColor="#ab0606ff" text="Processing" />;

//   return (
//     <Container
//       maxWidth="xl"
//       sx={{
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         overflow: 'hidden',
//         p: 2
//       }}
//     >
//       {/* Header */}
//       <Box sx={{ flexShrink: 0, mb: 2 }}>
//         <Button
//           startIcon={<ArrowBack />}
//           onClick={onBack}
//           sx={{
//             color: "text.primary",
//             borderRadius: "12px",
//             backgroundColor: "background.paper",
//             border: "1.5px solid #d32f2f",
//             "&:hover": { backgroundColor: "action.hover", borderColor: "#d32f2f" }
//           }}
//           variant="outlined"
//           size="small"
//         >
//           Back to Products
//         </Button>
//       </Box>

//       {/* Main Content */}
//       <Box sx={{
//         display: 'flex',
//         flexDirection: isMobile ? 'column' : 'row',
//         gap: 2,
//         flexGrow: 1,
//         overflow: 'hidden'
//       }}>
//         {/* Left Column - Product Info */}
//         <Box sx={{
//           width: isMobile ? '100%' : '30%',
//           minWidth: 300,
//           display: 'flex',
//           flexDirection: 'column',
//           gap: 2,
//           height: '100%'
//         }}>
//           <Paper sx={{ p: 2, flexGrow: 1,height: '100%' }}>
//             <Typography variant="h4" sx={{ fontWeight: 800, color: "primary.main" }}>
//               {product.produt_name}
//             </Typography>
//             <Chip
//               label={`${product.productCategory} Category`}
//               size="medium"
//               color="primary"
//               sx={{ mt: 1, fontWeight: 600 }}
//             />
//             <Box sx={{
//               mt: 2,
//               height: 220,
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center'
//             }}>
//               <img
//                 src={product.image_local_url
//                   ? `https://api-productcatelog.bilimbe.in/assets/${encodeURIComponent(product.image_local_url)}`
//                   : require("../assets/default-no-image.jpg")}
//                 alt={product.produt_name}
//                 style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
//               />
//             </Box>
//           </Paper>

//           {product.videoLink && product.videoLink !== "no video" && (
//             <Paper sx={{ p: 2 , flexShrink: 0}}>
//               <Stack spacing={2} alignItems="center">
//                 <Avatar sx={{ backgroundColor: "#D32F2F", width: 56, height: 56 }}>
//                   <PlayCircle color="white" />
//                 </Avatar>
//                 <Typography variant="h6" fontWeight={700}>Product Demonstration</Typography>
//                 <Button
//                   fullWidth
//                   variant="outlined"
//                   startIcon={<PlayCircle />}
//                   href={product.videoLink}
//                   target="_blank"
//                   sx={{ borderRadius: "8px" }}
//                 >
//                   Watch Video
//                 </Button>
//               </Stack>
//             </Paper>
//           )}
//         </Box>

//         {/* Middle Column - Deliverables/Requirements */}
//         <Box sx={{
//           flexGrow: 1,
//           minWidth: 200,
//           display: 'flex',
//           flexDirection: 'column',
//           height: '100%'
//         }}>
//           <Paper sx={{  borderRadius: 2, p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
//             <Tabs
//               value={activeTab}
//               onChange={(e, newValue) => setActiveTab(newValue)}
//                variant="scrollable"
//               sx={{ mb: 2, flexShrink: 0  }}
//             >
//               <Tab label="Deliverables" value="deliverablesdata" icon={<VolunteerActivismIcon />} />
//               <Tab label="Requirements" value="requirementsdata" icon={<FactCheckIcon />} />
//             </Tabs>
//             <Box sx={{flexGrow: 1, overflow: 'auto', maxHeight: 'calc(100% - 48px)' }}>
//               {activeTab === "deliverablesdata" && (
//                 <List dense>
//                   {product.deliverables?.map((spec, index) => (
//                     <ListItem key={index} sx={{ px: 0 }}>
//                       <ListItemIcon sx={{ minWidth: "36px" }}><CheckCircle color="primary" /></ListItemIcon>
//                       <ListItemText primary={spec} />
//                     </ListItem>
//                   ))}
//                 </List>
//               )}
//               {activeTab === "requirementsdata" && (
//                 <List dense>
//                   {product.reqFromClient?.map((item, index) => (
//                     <ListItem key={index} sx={{ px: 0 }}>
//                       <ListItemIcon sx={{ minWidth: "36px" }}><CheckCircle color="primary" /></ListItemIcon>
//                       <ListItemText primary={item} />
//                     </ListItem>
//                   ))}
//                 </List>
//               )}
//             </Box>
//           </Paper>
//         </Box>

//         {/* Right Column - Pricing */}
//         <Box sx={{
//           width: isMobile ? '100%' : '30%',
//           minWidth: 300,
//           display: 'flex',
//           flexDirection: 'column',
//           height: '100%',
//            gap: 2
//         }}>
//           <Paper sx={{  borderRadius: 2,
//                 p: 2,
//                 flexGrow: 1,
//                 overflow: 'auto',
//                 minHeight: isMobile ? 'auto' : '50%'  }}>
//             <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
//               Pricing Details
//             </Typography>
//             <PricingDetails
//               products={product}
//               selectCity={selectedCity}
//               onCityChange={handleCityChange}
//             />
//           </Paper>
//         </Box>
//       </Box>
//     </Container>
//   );
// };

// export default ProductDetailView;

import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Chip,
  Paper,
  Container,
  Avatar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Grid,
  Tab,
  Stack,
  useMediaQuery,
  useTheme,
  IconButton,
  Select,
  MenuItem,
  styled,
  Tooltip,
} from "@mui/material";
import {
  ArrowBack,
  CheckCircle,
  PlayCircle,
  ArrowForward,
  Category,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import useAxios from "../useAxios";
import { useSelector } from "react-redux";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ModernLoader from "./ModernLoder";
import { restoreAuth } from "../redux/slices/authSlice";
import PricingDetails from "./PricingDetails";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SouthIcon from "@mui/icons-material/South";
// Red-themed styled components
const RedGradientButton = styled(Button)(({ theme }) => ({
  background: "linear-gradient(45deg, #cf0433ff 0%, #f81616ff 100%)",
  color: "white",
  fontWeight: 600,
  //padding: "14px 28px",
  borderRadius: "12px",
  boxShadow: "0 4px 15px rgba(255, 65, 108, 0.3)",
  textTransform: "none",
  // fontSize: "1rem",
  "&:hover": {
    background: "linear-gradient(45deg, #cf0433ff 30%, #f81616ff 90%)",
    boxShadow: "0 6px 20px rgba(255, 75, 43, 0.4)",
  },
  transition: "all 0.3s ease",
}));
const ProductDetailView = ({ product, onBack }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const [selectedCity, setSelectedCity] = useState("");
  const [loading, setLoading] = useState(false);
  const axiosData = useAxios();
  const loggedInemail = useSelector((state) => state.auth.email);
  // State management at the top
  const [userDetails, setUserDetails] = useState();
  const [activeTab, setActiveTab] = useState("deliverablesdata");
  const [selectedTime, setSelectedTime] = useState("standard");
  const [cityStatus, setCityStatus] = useState("");
  const [durationType, setDurationType] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedDuration, setSelectedDuration] = useState("");
  const navigate = useNavigate();
  const computeCityStatus = (city) => {
    if (!city || !categories.length || !product) return;

    const formattedCity = city.charAt(0).toUpperCase() + city.slice(1);

    const productCityStatus = product?.status?.[formattedCity]?.toLowerCase();
    const category = categories.find(
      (c) => c._id === product.productCategoryID
    );
    const categoryCityStatus = category?.status?.[formattedCity]?.toLowerCase();

    const finalStatus =
      productCityStatus === "off" || categoryCityStatus === "off"
        ? "off"
        : "on";

    setCityStatus(finalStatus);
  };
  const handleCityChange = (city) => {
    setSelectedCity(city);
    computeCityStatus(city.toLowerCase());
    // const statusForCity =
    //   product?.status?.[city.charAt(0).toUpperCase() + city.slice(1)];
    // const cityStatus2 = statusForCity?.toLowerCase();
    // const catGet = categories.filter(
    //   (data) => data._id === product.productCategoryID
    // );
    // const statusForCityCat =
    //   catGet[0]?.status?.[city.charAt(0).toUpperCase() + city.slice(1)];
    // const cityStatus2Cat = statusForCityCat?.toLowerCase();
    // const finalStatus =
    //   cityStatus2?.toLowerCase() === "off" ||
    //   cityStatus2Cat?.toLowerCase() === "off"
    //     ? "off"
    //     : "on";

    // setCityStatus(finalStatus);
  };
  const handleToggleTab = () => {
    setActiveTab((prev) =>
      prev === "requirementsdata" ? "deliverablesdata" : "requirementsdata"
    );
  };
  const cityPrice = product.price.find(
    (item) =>
      item[userDetails?.city != undefined ? userDetails.city : "chennai"]
  );
  const hrs3to4Price = product.price.find((item) => item["3-4 Hrs"]);
  const hrs7to8Price = product.price[product.price.length - 3];
  const hrs11to12Price = product.price[product.price.length - 2];
  const days2Price = product.price.find((item) => item["2 Days"]);
  // Price calculation
  const basePrice = cityPrice
    ? cityPrice[userDetails?.city != undefined ? userDetails.city : "chennai"]
    : product.price.length > 0
    ? Object.values(product.price[0])[0]
    : 0;
  const basePrice3to4hrs = hrs3to4Price
    ? hrs3to4Price["3-4 Hrs"]
    : product.price.length > 0
    ? Object.values(product.price[0])[0]
    : 0;
  const basePrice7to8hrs = hrs7to8Price?.["7-8 Hrs"] ?? 0;
  const basePrice11to12hrs = hrs11to12Price ? hrs11to12Price["11-12 Hrs"] : 0;
  const basePrice2days = days2Price ? days2Price["2 Days"] : 0;
  // Calculate prices based on delivery time
  const standardPrice = basePrice;
  const expressPrice = Math.round(basePrice * 1.2); // 20% premium for express
  const fetchUser = async (email) => {
    try {
      const response = await axiosData.get(`getUser/${email}`);
      if (response.data) {
        setUserDetails(response.data.user);
        setSelectedCity(response.data.user?.city || "chennai");
        handleCityChange(response.data.user?.city);
        setLoading(false);
      }
    } catch (err) {
      console.error("User get error", err);
      setLoading(false);
    }
  };
  const fetchCategory = async () => {
    try {
      const data = await axiosData.get(`getAllProductCategory`);
      const productCategories = data.data.productCAtegory || [];
      setCategories(data.data.productCAtegory);
      computeCityStatus(selectedCity);
      // initialize city status for each category
      const initStatus = {};
      productCategories.forEach((cat) => {
        initStatus[cat._id] = cat.status || {}; // from API
      });
      setCityStatus(initStatus);
    } catch (error) {
      console.log("Error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    setActiveTab(event.target.value);
  };

  const handleCopy = () => {
    const textToCopy =
      activeTab === "deliverablesdata"
        ? product.deliverables?.join("\n") || ""
        : product.reqFromClient?.join("\n") || "";
    navigator.clipboard.writeText(textToCopy);
  };
  useEffect(() => {
    setCategories([]);
    setLoading(true);
    const storedAuth = localStorage.getItem("auth");
    const parsed = JSON.parse(storedAuth);
    fetchUser(parsed?.email);
    fetchCategory();
  }, [product]);
  // ? Re-check city status once product, userDetails and categories are loaded
  useEffect(() => {
    if (!userDetails || !categories.length || !product) return;

    const city = userDetails.city || "chennai";
    const formattedCity = city.charAt(0).toUpperCase() + city.slice(1);

    const productCityStatus = product?.status?.[formattedCity]?.toLowerCase();
    const categoryData = categories.find(
      (data) => data._id === product.productCategoryID
    );
    const categoryCityStatus =
      categoryData?.status?.[formattedCity]?.toLowerCase();

    const finalStatus =
      productCityStatus === "off" || categoryCityStatus === "off"
        ? "off"
        : "on";

    setSelectedCity(city);
    setCityStatus(finalStatus);
  }, [userDetails, categories, product]);

  if (!product || !userDetails) return null;
  if (loading)
    return (
      <ModernLoader size={80} primaryColor="#ab0606ff" text="Processing" />
    );

  return (
    <Container
      maxWidth="xl"
      sx={{
        height: isMobile ? "auto" : "89vh",
        display: "flex",
        flexDirection: "column",
        overflow: isMobile ? "visible" : "hidden",
        p: {
          xs: 1, // mobile
          sm: 2, // tablet
          md: 3, // laptop
          lg: 3, // desktop
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          flexShrink: 0,
          mb: {
            xs: 1, // mobile
            sm: 1, // tablet
            md: 2, // laptop
            lg: 2, // desktop
          },
        }}
      >
        <Button
          startIcon={<ArrowBack />}
          onClick={onBack}
          sx={{
            color: "text.primary",
            borderRadius: "12px",
            backgroundColor: "background.paper",
            border: "1.5px solid #d32f2f",
            "&:hover": {
              backgroundColor: "action.hover",
              borderColor: "#d32f2f",
            },
            fontSize: {
              xs: "0.8rem",
              sm: "0.9rem",
            },
          }}
          variant="outlined"
          size={isMobile ? "small" : "small"}
        >
          Back
        </Button>
      </Box>

      {/* Main Content */}
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? 2 : 1,
          flexGrow: 1,
          //      ...(cityStatus === "off" && {
          //   filter: "blur(3px)",
          //   pointerEvents: "none",
          //   userSelect: "none",
          // }),
          overflow: isMobile ? "visible" : "hidden",
          height: isMobile ? "auto" : "calc(100% - 50px)", // Subtract header height
        }}
      >
        {/* Left + Middle + Right sections */}
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            flexGrow: 1,
            position: "relative",
            ...(cityStatus === "off" && {
              filter: "blur(3px)",
              pointerEvents: "none",
              userSelect: "none",
            }),
          }}
        >
          {/* Left Column - Product Info */}
          <Box
            sx={{
              // width: isMobile ? "100%" : "40%",
              //minWidth: isMobile ? "auto" : 300,
              display: "flex",
              flexDirection: "column",
              gap: {
                xs: 2,
                sm: 2,
                md: 2,
              },
              height: "100%",
            }}
          >
            <Box sx={{ flexShrink: 0 }}>
              <Typography
                variant={isMobile ? "h6" : isTablet ? "h5" : "h5"}
                sx={{
                  fontWeight: 800,
                  color: "primary.main",
                  fontSize: {
                    xs: "1.25rem",
                    sm: "1.5rem",
                    md: "1.75rem",
                  },
                }}
              >
                {product.produt_name}
              </Typography>
              <Box
                sx={{
                  // // width: isMobile ? "100%" : "40%",
                  // minWidth: isMobile ? 300 : 300,
                  // display: "flex",
                  // flexDirection: isMobile ?"column":"row",
                  // justifyContent: "space-between",
                  // height: isMobile ? "auto" : "100%",
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  justifyContent: "space-between",
                  alignItems: isMobile ? "flex-start" : "center",
                  gap: isMobile ? 1 : 0,
                  mt: 1,
                }}
              >
                <Chip
                  onClick={() => {
                    navigate("/user-dashboard/", {
                      state: { selectedCategory: product.productCategoryID },
                    });
                  }}
                  label={`${product.productCategory} Category`}
                  size={isMobile ? "medium" : "medium"}
                  color="primary"
                  sx={{
                    mt: 1,
                    fontWeight: 600,
                    fontSize: {
                      xs: "0.7rem",
                      sm: "0.8rem",
                    },
                  }}
                />
                <Box
                  sx={{
                    marginRight: isMobile ? "0px" : "5px",
                    marginTop: isMobile ? "5px" : "5px",
                  }}
                >
                  {product.videoLink && product.videoLink !== "no video" && (
                    // <Paper
                    //   sx={{
                    //     p: 1,
                    //     flexShrink: 0,
                    //     overflow: "auto",
                    //     opacity: cityStatus === "off" ? 0.5 : 1,
                    //     pointerEvents: cityStatus === "off" ? "none" : "auto",
                    //   }}
                    // >
                    <Stack spacing={1} alignItems="center">
                      <Box
                        sx={{
                          mt: isMobile ? 0 : "5px",
                          width: isMobile ? "100%" : "auto",
                        }}
                      >
                        <RedGradientButton
                          fullWidth={isMobile}
                          startIcon={<PlayCircle />}
                          href={product.videoLink}
                          target="_blank"
                          size={isMobile ? "small" : "medium"}
                          sx={{
                            fontSize: {
                              xs: "0.8rem",
                              sm: "0.9rem",
                            },
                          }}
                        >
                          Click here for Videos & Outputs
                        </RedGradientButton>
                      </Box>
                    </Stack>
                    // </Paper>
                  )}
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                // mt: 1,
                // mr: 1,
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                flexShrink: 0,
                // flexGrow: 1,
                mr: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // position: "relative"
              }}
            >
              <Tooltip title="Right click to copy image " followCursor arrow>
                <img
                  src={
                    product.image_local_url
                      ? `https://api-productcatelog.bilimbe.in/assets/${encodeURIComponent(
                          product.image_local_url
                        )}`
                      : require("../assets/default-no-image.jpg")
                  }
                  alt={product.produt_name}
                  style={{
                    maxWidth: "100%",
                    width: "auto",
                    maxHeight: isMobile
                      ? "300px"
                      : isTablet
                      ? "300px"
                      : "300px",
                    objectFit: "contain",
                    filter:
                      // product?.status?.[
                      //   selectedCity.charAt(0).toUpperCase() +
                      //     selectedCity.slice(1)
                      // ]?.toLowerCase() === "off"
                      cityStatus === "off"
                        ? "grayscale(1) brightness(0.6)"
                        : "none",
                    pointerEvents:
                      // product?.status?.[
                      //   selectedCity.charAt(0).toUpperCase() +
                      //     selectedCity.slice(1)
                      // ]?.toLowerCase() === "off"
                      cityStatus === "off" ? "none" : "auto",
                  }}
                />
              </Tooltip>
              {/* Overlay if product is OFF in selected city */}
              {
                // product?.status?.[
                //   selectedCity.charAt(0).toUpperCase() + selectedCity.slice(1)
                // ]?.toLowerCase() === "off"
                cityStatus === "off" && (
                  <Tooltip title="Product Currently Unavailable" followCursor>
                    <Box
                      sx={{
                        position: "absolute",
                        //inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 999,
                        boxShadow: 24,
                      }}
                    >
                      <Typography
                        sx={{
                          backgroundColor: "#fff",
                          color: "#d32f2f",
                          px: 4,
                          py: 1.5,
                          borderRadius: "32px",
                          fontWeight: 700,
                          fontSize: { xs: "1rem", sm: "1rem" },
                          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                        }}
                      >
                        ?? Product Currently Unavailable in{" "}
                        {selectedCity.charAt(0).toUpperCase() +
                          selectedCity.slice(1)}
                        <Typography
                          variant="body1"
                          sx={{
                            textAlign: "center",
                            fontWeight: 100,
                            fontSize: { xs: "0.6rem", sm: "0.6rem" },
                            //textTransform: "uppercase",
                          }}
                        >
                          Please check other cities or contact support for more
                          information
                        </Typography>
                      </Typography>
                    </Box>
                  </Tooltip>
                )
              }
            </Box>
          </Box>
          {/* Middle Column - Deliverables/Requirements */}
          <Box
            sx={{
              flexGrow: 1,
              width: isMobile ? "100%" : 300,
              mr: 1,
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <Box sx={{ flexShrink: 0,display:"flex",justifyContent:"center",flexDirection:isMobile?"column" :null}}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: 2,
                  textAlign:"center",
                  width: { xs: "100%", sm: 350 },
                  // width: "100%", // ? Responsive
                  p: 1,
                 mb: isMobile?2:0,
                  boxShadow: 1,
                }}
              >
                <Tooltip
                  title="Click to view other options"
                  arrow
                  placement="top"
                >
                  <Box sx={{  width: { xs: "100%", sm: 300 } }}>
                    {/* ? Visible only on mobile */}
                    <Typography
                      variant="caption"
                      sx={{
                        display: { xs: "block", sm: "none" },
                        color: "#D32F2F",
                        fontWeight: 500,
                        textAlign: "center",
                        mb: 0.5,
                      }}
                    >
                      Tap to view more options{" "}
                      <SouthIcon
                        sx={{ fontSize: "13px", verticalAlign: "middle" }}
                      />
                    </Typography>
                    <Select
                      value={activeTab}
                      onChange={handleChange}
                      IconComponent={ArrowDropDownIcon}
                      sx={{
                        width: { xs: "100%", sm: 300 }, // ? Responsive
                        fontWeight: "bold",
                        color: "#D32F2F",
                        "& .MuiSelect-icon": {
                          color: "#D32F2F",
                        },
                      }}
                    >
                      <MenuItem value="deliverablesdata">
                        <Box display="flex" alignItems="center" gap={1}>
                          <VolunteerActivismIcon color="error" />
                          <Typography
                            fontWeight="bold"
                            sx={{
                              fontSize: {
                                xs: "0.8rem",
                                sm: "0.9rem",
                              },
                            }}
                          >
                            Deliverables from Bilimbe
                          </Typography>
                        </Box>
                      </MenuItem>

                      <MenuItem value="requirementsdata">
                        <Box display="flex" alignItems="center" gap={1}>
                          <FactCheckIcon color="error" />
                          <Typography
                            fontWeight="bold"
                            sx={{
                              fontSize: {
                                xs: "0.8rem",
                                sm: "0.9rem",
                              },
                            }}
                          >
                            To be needed from client side
                          </Typography>
                        </Box>
                      </MenuItem>
                    </Select>
                  </Box>
                </Tooltip>

                <IconButton
                  onClick={handleCopy}
                  sx={{ ml: 1, display: { xs: "none", sm: "flex" } }}
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Box>
              {/* Mobile Copy Button */}
              <Box
                sx={{
                  display: { xs: "flex", sm: "none" },
                  justifyContent: "center",
                  mb: 1,
                }}
              >
                <Button
                  startIcon={<ContentCopyIcon />}
                  onClick={handleCopy}
                  size="small"
                  variant="outlined"
                >
                  Copy List
                </Button>
              </Box>
            </Box>

            <Box
              sx={{
                flexGrow: 1,
                overflow: "auto",
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "3px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {activeTab === "deliverablesdata" && (
                // <List dense sx={{ width: 300 }}>
                //   {product.deliverables?.map((spec, index) => (
                //     <ListItem key={index} sx={{ px: 0 }}>
                //       <ListItemIcon sx={{ minWidth: "36px" }}>
                //         <CheckCircle color="primary" />
                //       </ListItemIcon>
                //       <ListItemText primary={spec} />
                //     </ListItem>
                //   ))}
                // </List>
                <List dense sx={{  width: { xs: "100%", sm: 300 }, }}>
                  {product.deliverables?.map((spec, index) => {
                    const isNote = spec.toLowerCase().startsWith("note:");
                    return (
                      <ListItem key={index} sx={{ px: 0 }}>
                        <ListItemIcon
                          sx={{
                            minWidth: {
                              xs: "32px",
                              sm: "36px",
                            },
                          }}
                        >
                          <CheckCircle
                            color="primary"
                            fontSize={isMobile ? "small" : "medium"}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primaryTypographyProps={{
                            fontWeight: isNote ? "bold" : "normal",
                            fontSize: {
                              xs: "0.9rem",
                              sm: "0.9rem",
                            },
                          }}
                          primary={spec}
                        />
                      </ListItem>
                    );
                  })}
                </List>
              )}
              {activeTab === "requirementsdata" && (
                <List densesx={{ width: { xs: "100%", sm: 300 }, }}>
                  {product.reqFromClient?.map((item, index) => (
                    <ListItem key={index} sx={{ px: 0 }}>
                      <ListItemIcon
                        sx={{
                          minWidth: {
                            xs: "32px",
                            sm: "36px",
                          },
                        }}
                      >
                        <CheckCircle
                          color="primary"
                          fontSize={isMobile ? "small" : "medium"}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={item}
                        primaryTypographyProps={{
                          fontSize: {
                            xs: "0.9rem",
                            sm: "0.9rem",
                          },
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              )}
            </Box>
          </Box>
        </Box>
        {/* Right Column - Pricing */}
        <Box
          sx={{
            width: isMobile ? "100%" : 300,
            display: "flex",
            flexDirection: "column",
            height: "100%",
            gap: {
              xs: 1,
              sm: 2,
            },
          }}
        >
          <Typography
            variant={isMobile ? "h6" : "h6"}
            gutterBottom
            sx={{
              flexShrink: 0,
              textAlign: "center",
              fontWeight: 800,
              color: "primary.main",
              fontSize: {
                xs: "1.1rem",
                sm: "1.25rem",
              },
            }}
          >
            Pricing Details
          </Typography>
          <Box
            sx={{
              flexGrow: 1,
              overflow: "auto",
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#888",
                borderRadius: "3px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "#555",
              },
            }}
          >
            <PricingDetails
              products={product}
              selectCity={selectedCity}
              onCityChange={handleCityChange}
              userDetails={userDetails}
              disablePricing={cityStatus === "off"} // NEW: pass flag to disable prices
            />
          </Box>
        </Box>

        {/* Overlay Message (when unavailable) */}
        {cityStatus === "off" && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
              textAlign: "center",
              p: 3,
              backgroundColor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              width: {
                xs: "90%",
                sm: "80%",
                md: "60%",
                lg: "40%",
              },
            }}
          >
            <Typography
              variant={isMobile ? "h6" : "h5"}
              color="error"
              sx={{ fontWeight: 700, mb: 1 }}
            >
              Product Currently Unavailable in{" "}
              {selectedCity.charAt(0).toUpperCase() + selectedCity.slice(1)}
            </Typography>
            <Typography variant={isMobile ? "body2" : "body1"}>
              Please check other cities or contact support for more information
            </Typography>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default ProductDetailView;
